import { useQuery } from '@tanstack/react-query';
import { RFI_QUERY_KEYS } from 'app/modules/rfi/queries/keys';
import { get } from 'app/shared/utils/fetchr';
import { RfiTemplate } from 'app/modules/rfi/responses';

export interface RfiTemplatesListResponse {
  templates: RfiTemplate[];
}

export const useListRfiTemplates = () => {
  return useQuery({
    queryKey: RFI_QUERY_KEYS.listTemplates(),
    queryFn: () => get<RfiTemplatesListResponse>('/v1/rfi/templates'),
  });
};
